// extracted by mini-css-extract-plugin
export default {"topBannerMobileSlot":"TopBrazeBannerMobile_topBannerMobileSlot__xg8vj"};